<template>
  <div class="about">
    <div class="group">
      <h2>关于我们</h2>
      <div class="img_group">
        <div
          :class="{ active: isborder == 1 }"
          @click="handleTeam('1')"
          class="line_box"
        >
          <div
            :class="{ active_fir: imgUrl == 1 }"
            class="img_fir img_icon"
          ></div>
          <div class="about_tit">企业简介</div>
        </div>
        <div
          :class="{ active: isborder == 2 }"
          @click="handleTeam('2')"
          class="line_box"
        >
          <div
            :class="{ active_sec: imgUrl == 2 }"
            class="img_sec img_icon"
          ></div>
          <div class="about_tit">领导团队</div>
        </div>
        <div
          :class="{ active: isborder == 3 }"
          @click="handleTeam('3')"
          class="line_box"
        >
          <div
            :class="{ active_thi: imgUrl == 3 }"
            class="img_thi img_icon"
          ></div>
          <div class="about_tit">发展历程</div>
        </div>
      </div>
      <div class="container">
        <template v-if="isTab == 1">
          <div class="item-box box_backimg">
            <div>
              <div class="qy_content">
                <h2>企业简介</h2>
                <div class="line mt-30"></div>
                <div class="home_content" v-html="homeData.content"></div>
              </div>

              <router-link
                :to="{
                  name: ylStatus ? 'about_yl' : 'about',
                  query: { routerPath: 'qyjj' }
                }"
              >
                <el-button class="el-primary-border">查看详情</el-button>
              </router-link>
            </div>
            <div class="box-right">
              <div class="right-img">
                <img :src="homeData.rightImg" />
              </div>
              <div class="bottom-img">
                <img :src="homeData.leftImg" />
              </div>
            </div>
          </div>
        </template>
        <template v-if="isTab == 2">
          <div class="item-box item-team">
            <div class="title_msg">
              <h2>核心团队介绍</h2>
              <!-- <p>
                高度一致的工作理念和价值观发展愿景：力求成为中国商用车融资服务领军型企业
                打造专业、高效的融资服务商
              </p>-->
            </div>
            <div class="swiper_team">
              <swiper :options="swiperOption" class="swiper">
                <swiper-slide>
                  <div class="group-item">
                    <img alt="胡象应先生" src="@image/h.png" />
                    <div class="job-name">
                      <div>
                        <span>胡象应先生</span>
                        <span class="post">董事长</span>
                      </div>
                      <p class="four-ell">
                        清华大学毕业。10余年国有银行、10余年商用车融资服务行业从业及管理经历。凭借丰富的金融行业经验及对行业的深刻洞察，
                        2015年9月，胡象应先生牵头组建湖北品农商用车服务有限公司，任董事长至今。
                      </p>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="group-item">
                    <img alt="杨勇先生" src="@image/y.png" />
                    <div class="job-name">
                      <div>
                        <span>杨勇先生</span>
                        <span class="post">总经理</span>
                      </div>
                      <p class="four-ell">
                        中南财经政法大学毕业。8年的高校教学和学报编辑经历，20余年股份制银行支行行长、分行营业部总经理、分行办公室主任，二级分行行长的工作经验。2015年9月任湖北品农商用车服务有限公司总经理至今。
                      </p>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="group-item">
                    <img alt="汪新民先生" src="@image/w.png" />
                    <div class="job-name">
                      <div>
                        <span>汪新民先生</span>
                        <span class="post">副总经理</span>
                      </div>
                      <p class="four-ell">
                        华中科技大学电子工程本科、清华大学汽车信息工程研究生毕业。20余年软件开发管理经历，参与国内多个互联网重点项目的开发，高校电子控制系兼职教授。2015年9月任湖北品农商用车服务有限公司副总经理至今。
                      </p>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="group-item">
                    <img alt="吴世云先生" src="@image/wsy.png" />
                    <div class="job-name">
                      <div>
                        <span>吴世云先生</span>
                        <span class="post">副总经理</span>
                      </div>
                      <p class="four-ell">
                        清华大学毕业。10余年设计院、商业地产工作经历，10余年商用车行业从业及管理经历。2015年9月任湖北品农商用车服务有限公司副总经理、市场营销负责人至今。
                      </p>
                    </div>
                  </div>
                </swiper-slide>
                <!-- <swiper-slide>
                  <div class="group-item">
                    <img
                      alt="马雪峰女士"
                      src="@image/m.png"
                      style="left:35px"
                    />
                    <div class="job-name">
                      <div>
                        <span>马雪峰女士</span>
                        <span class="post">总经理助理</span>
                      </div>
                      <p class="four-ell">
                        中南财经政法大学会计本科、华中师范大学区域经济学研究生毕业。近20年合资企业从业及管理经历。2017年6月加入湖北品农商用车服务有限公司，2020年6月任公司总经理助理至今。
                      </p>
                    </div>
                  </div>
                </swiper-slide> -->
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
            <router-link
              :to="{
                name: ylStatus ? 'about_yl' : 'about',
                query: { routerPath: 'ldtd' }
              }"
            >
              <el-button class="el-primary-border btn_msg">查看详情</el-button>
            </router-link>
          </div>
        </template>
        <template v-if="isTab == 3">
          <div
            class="item-box back_fzlc"
            :style="{ background: 'url( ' + homeData.img + ')' }"
          >
            <router-link
              :to="{
                name: ylStatus ? 'about_yl' : 'about',
                query: { routerPath: 'fzlc' }
              }"
            >
              <el-button class="el-primary-border" style="width:98px"
                >查看详情</el-button
              >
            </router-link>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  name: 'AboutPn',
  data() {
    return {
      isTab: 1,
      isborder: 1,
      imgUrl: 1,
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 0,
        slidesPerGroup: 2,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      ylStatus: this.$store.getters.urlStatus
    }
  },

  computed: {
    homeData() {
      let data = this.$store.getters.homeData
      let contentMsg = {}
      if (data) {
        for (const key in data) {
          switch (data[key].sign) {
            case 'syqyjjjzw':
              contentMsg.content = data[key].content
              break
            case 'syfzlc':
              contentMsg.img = data[key].content
              break
            case 'sytpzy':
              contentMsg.leftImg = data[key].content
              break
            case 'sytpyy':
              contentMsg.rightImg = data[key].content
              break
          }
        }
      }
      return contentMsg
    }
  },
  methods: {
    handleTeam(num) {
      this.isTab = num
      this.isborder = num
      this.imgUrl = num
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  background: #f9faff;
  position: relative;
  height: 800px;
  padding: 120px 0;
  .group {
    width: 1300px;
    margin: 50px auto 80px auto;
    h2 {
      text-align: center;
      font-size: 30px;
      font-weight: 400;
      color: rgba(35, 35, 35, 1);
    }
    .img_group {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .active {
        border-bottom: 2px solid #707070;
      }
      .about_tit {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-top: 20px;
      }

      .line_box {
        padding: 25px;
        cursor: pointer;
      }
      .img_icon {
        width: 60px;
        height: 55px;
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 10px;
      }
      .img_icon:hover {
        animation: circle 1.5s linear 0s;
      }
      /*关键帧动画*/
      @-webkit-keyframes circle {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      .img_fir {
        background-image: url('../../assets/image/icon-qy.png');
      }
      .img_sec {
        background-image: url('../../assets/image/icon-td.png');
      }
      .img_thi {
        background-image: url('../../assets/image/icon-fz.png');
      }
      .active_fir {
        background-image: url('../../assets/image/icon-qy1.png');
      }
      .active_sec {
        background-image: url('../../assets/image/icon-td1.png');
      }
      .active_thi {
        background-image: url('../../assets/image/icon-fz1.png');
      }
    }
  }
  .container {
    height: 545px;
    background: #fff;
    position: relative;
    .btn_msg {
      width: 98px;
      position: absolute;
      bottom: 35px;
      left: 0;
      right: 0;
      margin: auto;
      border-color: #0d7ef8;
      color: #0d7ef8;
      border-radius: 0;
    }
    .btn_msg:hover {
      color: #fff;
      background-color: #0d7ef8;
    }
    .item-box {
      .title_msg {
        h2 {
          padding-top: 50px;
          font-size: 30px;
          font-weight: 400;
          color: rgba(35, 35, 35, 1);
        }
        p {
          margin-top: 50px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 26px;
        }
      }
      .qy_content {
        width: 600px;
        padding: 60px 120px;
        // padding: 50px 120px 60px 120px;
        text-align: initial;

        h2 {
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 25px;
        }
        .line {
          width: 19px;
          height: 5px;
          background: rgba(13, 126, 248, 1);
        }
        .home_content {
          /deep/p {
            font-size: 14px !important;
            font-weight: 400 !important;
            line-height: 35px !important;
            color: rgba(85, 85, 85, 1) !important;
            span {
              font-size: 14px !important;
              font-weight: 400 !important;
              line-height: 35px !important;
              color: rgba(85, 85, 85, 1) !important;
            }
          }
        }
        // p {
        //   text-indent: 30px;
        //   line-height: 35px;
        //   font-size: 14px;
        //   font-weight: 400;
        //   color: rgba(85, 85, 85, 1);
        // }
      }

      .swiper_team {
        background-size: contain;
        height: 115px;
      }
      .group-item {
        position: relative;
        height: 230px;
        display: flex;
        background: #fff;
        box-shadow: 0px 8px 46px 4px rgba(207, 207, 207, 0.3);
        margin: 80px 0px 50px 0px;
        min-width: 500px;
        max-width: 570px;
        img {
          position: absolute;
          top: -20px;
          height: 250px;
          left: 20px;
        }
        .job-name {
          padding: 30px;
          margin-left: 195px;
          font-size: 24px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          text-align: start;
          .post {
            font-size: 18px;
            font-weight: 400;
            color: rgba(13, 126, 248, 1);
            margin-left: 30px;
          }
          p {
            margin-top: 30px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 27px;
            text-align: start;
          }
        }
      }
    }
    .item-team {
      background: url('../../assets/image/team.png') no-repeat center 85px;
    }
    .box_backimg {
      position: relative;
      display: flex;
      background: url('../../assets/image/about_img.png') no-repeat;
      height: 545px;
      background-size: contain;
      // background-size: 100% 100%;
      .box-right {
        background-color: #f3f5f8;
        width: 100%;
        padding: 40px;
        position: relative;

        .right-img {
          img {
            height: 450px;
            width: 100%;
            object-fit: cover;
          }
        }
        .bottom-img {
          position: absolute;
          bottom: 0;
          right: 180px;
          img {
            height: 200px;
          }
        }
      }
      .el-primary-border {
        position: absolute;
        left: 220px;
        bottom: 50px;
        border-color: #0d7ef8;
        color: #0d7ef8;
        border-radius: 0;
      }
      .el-primary-border:hover {
        color: #fff;
        background-color: #0d7ef8;
      }
    }
    .back_fzlc {
      // background: url('../../assets/image/fzlc.png') no-repeat;
      height: 545px;
      width: 100%;
      position: relative;
      background-size: 100% 100% !important;
      background-repeat: no-repeat !important;
      .el-primary-border {
        position: absolute;
        left: 0;
        bottom: 50px;
        right: 0;
        margin: auto;
        border-color: #0d7ef8;
        color: #0d7ef8;
        border-radius: 0;
      }
      .el-primary-border:hover {
        color: #fff;
        background-color: #0d7ef8;
      }
    }
  }
  .swiper-container {
    padding-left: 47px;
  }
  // .swiper-slide {
  //   width: 0;
  // }
  /deep/.swiper-button-prev,
  .swiper-button-next {
    color: #0d7ef8 !important;
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-family: swiper-icons;
    text-align: center;
    font-size: 15px;
    text-transform: none !important;
    letter-spacing: 0;
    text-transform: none;
    font-variant: initial;
    line-height: 2;
    width: 25px;
    height: 27px;
    background: rgba(246, 248, 253, 1);
  }
}
</style>
